import { gql } from "@apollo/client";
export default gql`
  mutation QueueDownloadClinicIds($input: QueueDownloadClinicsInput!) {
    queueDownloadClinicIds(input: $input)
  }
`;
